// extracted by mini-css-extract-plugin
export default {"tableContainer":"Qqc5KpkYWHZRH62AWoMR"};